(() => {
  const initialized = new WeakSet();
  let restoreFocus = null;
  let pointerStartedOnBackdrop = false;

  const initializeConsent = (root = document) => {
    root.querySelectorAll('[data-terms-form]').forEach((form) => {
      if (initialized.has(form)) return;
      initialized.add(form);
      const checkbox = form.querySelector('[data-terms-checkbox]');
      if (!checkbox) return;
      const submit = form.querySelector('[data-terms-submit]');
      const accelerated = form.querySelector('[data-terms-accelerated]');
      const hint = form.querySelector('[data-terms-hint]');
      const update = () => {
        const accepted = checkbox.checked;
        if (submit) submit.disabled = !accepted || submit.dataset.unavailable === 'true';
        if (accelerated) {
          const unavailable = submit?.dataset.unavailable === 'true';
          accelerated.hidden = !accepted || unavailable;
          accelerated.inert = !accepted || unavailable;
        }
        if (hint) hint.hidden = accepted;
      };
      checkbox.checked = false;
      update();
      checkbox.addEventListener('change', update);
      form.addEventListener('submit', (event) => {
        if (form.dataset.termsForm === 'cart' && event.submitter?.name !== 'checkout') return;
        if (!checkbox.checked) {
          event.preventDefault();
          event.stopImmediatePropagation();
          checkbox.reportValidity();
          checkbox.focus();
        }
      }, true);
    });
  };

  const initializeDialog = () => {
    const dialog = document.querySelector('[data-terms-dialog]');
    if (!dialog) return;
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-open-terms]');
      if (opener && typeof dialog.showModal === 'function') {
        event.preventDefault();
        restoreFocus = opener;
        if (!dialog.open) dialog.showModal();
        dialog.querySelector('.terms-dialog-body').scrollTop = 0;
        document.body.classList.add('terms-dialog-open');
      }
      if (event.target.closest('[data-close-terms]') && dialog.open) dialog.close();
    });
    dialog.addEventListener('pointerdown', (event) => {
      const rect = dialog.getBoundingClientRect();
      pointerStartedOnBackdrop = event.target === dialog &&
        (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
    });
    dialog.addEventListener('click', (event) => {
      const rect = dialog.getBoundingClientRect();
      const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      if (pointerStartedOnBackdrop && event.target === dialog && outside) dialog.close();
      pointerStartedOnBackdrop = false;
    });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('terms-dialog-open');
      if (restoreFocus?.isConnected) restoreFocus.focus();
    });
  };

  const start = () => { initializeConsent(); initializeDialog(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', (event) => initializeConsent(event.target));
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-terms-checkbox]').forEach((checkbox) => {
      checkbox.checked = false;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
})();
